/* tslint:disable */
import {
  ModuleCategory
} from '../index';

declare var Object: any;
export interface GroupsInterface {
  "id"?: number;
  "name"?: string;
  "active"?: boolean;
  "category_id"?: number;
  "full_name"?: string;
  categories?: ModuleCategory;
}

export class Groups implements GroupsInterface {
  "id": number;
  "name": string;
  "active": boolean;
  "category_id": number;
  "full_name": string;
  categories: ModuleCategory;
  constructor(data?: GroupsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Groups`.
   */
  public static getModelName() {
    return "Groups";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Groups for dynamic purposes.
  **/
  public static factory(data: GroupsInterface): Groups{
    return new Groups(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Groups',
      plural: 'Groups',
      path: 'Groups',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "category_id": {
          name: 'category_id',
          type: 'number'
        },
        "full_name": {
          name: 'full_name',
          type: 'string'
        },
      },
      relations: {
        categories: {
          name: 'categories',
          type: 'ModuleCategory',
          model: 'ModuleCategory',
          relationType: 'belongsTo',
                  keyFrom: 'category_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Groups.ts